module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("裂变红包详情")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "promotion-ditail"
  }, [_c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("红包名称")]), _c('div', [_vm._v(_vm._s(_vm.envelopeInfo.info.name))])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("适用门店")]), _vm._v(" "), _c('div', [_c('ol', _vm._l((_vm.envelopeInfo.info.use_shop_list || []), function(item) {
    return _c('li', [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("消费金额")]), _vm._v(" "), (_vm.envelopeInfo.info.send_rule.pay_fee) ? _c('div', [_vm._v(_vm._s(_vm.envelopeInfo.info.send_rule.pay_fee) + "元")]) : _c('div', [_vm._v("不限制")])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("发放红包个数")]), _c('div', [_vm._v(_vm._s(_vm.envelopeInfo.info.send_rule.count) + "个")])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("发放红包总金额")]), _c('div', [_vm._v(_vm._s(_vm.envelopeInfo.info.send_rule.amount) + "元")])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("单个红包最小金额")]), _c('div', [_vm._v(_vm._s(_vm.envelopeInfo.info.send_rule.single_min_amount) + "元")])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("单个红包最大金额")]), _c('div', [_vm._v(_vm._s(_vm.envelopeInfo.info.send_rule.single_max_amount) + "元")])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("使用条件")]), _vm._v(" "), (_vm.envelopeInfo.info.use_rule > 0) ? _c('div', [_vm._v("消费满" + _vm._s(_vm._f("filterMoney")(_vm.envelopeInfo.info.use_rule)) + "元才能使用红包")]) : _c('div', [_vm._v("不限制")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-68092b71","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/marketing/red_packet/RedPackInfo.vue
// module id = 861
// module chunks = 0